import { List } from 'immutable';
import { createSelector } from '../../../node_modules/reselect';
import { selectType, selectPayload, selectQuery } from '../location/selectors';
import { selectUsersById, currentUserSelector } from '../Users/selectors';
import { ROUTE_USER_PROFILE_PAGE } from '../routeActions';
import { PROFILE_PAGE_PORTFOLIO } from '../../web/containers/ProfilePage/consts';

export const DEFAULT_VISIBILITY_FILTER = 'show';
export const DEFAULT_ORDER_BY = '-postedAt';
export const DEFAULT_LIMIT = 48;
export const DEFAULT_COURSE_SELECTED = null;

export const selectCurrentPageIsPortfolioPage = createSelector(
  [selectType, selectPayload],
  (type, params) =>
    type === ROUTE_USER_PROFILE_PAGE &&
    params.get('page') === PROFILE_PAGE_PORTFOLIO
);

export const selectCurrentProfileUserProfileName = createSelector(
  [selectType, selectPayload],
  (type, params) =>
    type === ROUTE_USER_PROFILE_PAGE && params.get('profileName')
);

export const selectCurrentProfileUserId = createSelector(
  [selectCurrentProfileUserProfileName, selectUsersById],
  (profileName, usersById) => {
    const user = usersById.find((u) => u.get('profileName') === profileName);
    if (user) {
      return user.get('id');
    } else {
      return null;
    }
  }
);

export const selectCurrentPortfolioVisibilityFilter = createSelector(
  [selectQuery],
  (query) => {
    const visibilityFilter = query.get('visibilityFilter');
    if (visibilityFilter) {
      return visibilityFilter;
    } else {
      return DEFAULT_VISIBILITY_FILTER;
    }
  }
);

export const selectCurrentPortfolioSortBy = createSelector(
  [selectQuery],
  (query) => {
    const stringQuery = query.get('sortBy');
    if (stringQuery) {
      return stringQuery;
    } else {
      return DEFAULT_ORDER_BY;
    }
  }
);

export const selectCurrentPortfolioLimit = createSelector(
  [selectQuery],
  (query) => {
    const stringQuery = query.get('limit');
    if (stringQuery) {
      return parseInt(stringQuery, 10);
    } else {
      return DEFAULT_LIMIT;
    }
  }
);

export const selectCurrentPortfolioCourseFilter = createSelector(
  [selectQuery],
  (query) => {
    const stringQuery = query.get('courseSelected');
    if (stringQuery) {
      return stringQuery;
    } else {
      return new List();
    }
  }
);

export const selectCurrentPortfolioQuery = createSelector(
  [selectQuery, selectCurrentProfileUserId, currentUserSelector],
  (query, userId, activeUser) => {
    let portfolioQuery = null;
    let isAuthor = false;

    if (activeUser) {
      isAuthor = activeUser.get('id') === userId;
    }

    if (query === undefined) {
      if (userId) {
        portfolioQuery = {
          userId,
          filterBy: null,
          sortBy: DEFAULT_ORDER_BY,
          limit: DEFAULT_LIMIT,
          isAuthor,
        };
      }
    } else {
      let filterBy = null;
      const limit = query.get('limit')
        ? parseInt(query.get('limit'), 10)
        : DEFAULT_LIMIT;

      if (query.get('courseSelected')) {
        filterBy = query.get('courseSelected');
      }

      if (userId) {
        portfolioQuery = {
          userId,
          filterBy,
          sortBy: query.get('sortBy') || DEFAULT_ORDER_BY,
          limit,
          isAuthor,
        };
      }
    }

    return portfolioQuery;
  }
);
